/**
 * Clamp a card's top-left {x,y} so it stays usable within the viewport.
 * Keeps at least `margin` px of the card on screen on every edge, and keeps
 * the top edge (the drag grip) at or below 0 and above vh-margin.
 */
export function clampToViewport({ x, y, w, h, vw, vh, margin = 40 }) {
  const minX = margin - w;        // card can slide left until `margin` px remain
  const maxX = vw - margin;       // ...or right until `margin` px remain
  const minY = 0;                 // never above the top (grip must be reachable)
  const maxY = vh - margin;       // never below: keep the grip on screen
  return {
    x: Math.min(maxX, Math.max(minX, x)),
    y: Math.min(maxY, Math.max(minY, y)),
  };
}
